import styled from 'styled-components';
import { Typography } from '@mui/material';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const BrListItemWrapper = styled.div<any>`
  margin: 10px;
  padding: 10px;
  min-width: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    margin: 0;
    padding: 8px 5px;
    min-width: unset;
  }
`;

export const BrListItemImage = styled.img`
  height: 85px;

  @media (max-width: 768px) {
    height: 40px;
  }
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const BrListItemLabel = styled(Typography as any)`
  max-width: 160px;
  text-align: center;
  font-size: 1.5em;
  margin-top: 15px !important;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    max-width: 100%;
    font-size: 0.75em !important;
    margin-top: 5px !important;
    line-height: 1.2 !important;
  }
`;
